<template>
  <div v-if="justView" class="mt-2">
    <div
      class="answer-area mb-4"
      :style="{
        color: textColor || '#000000',
      }"
    >
      <span class="text-addquestion">{{ text }}</span>
      <span>{{ answerText }}</span>
    </div>
    <hr />
  </div>

  <div v-else>
    <div v-if="addQuestionTemplate === 'default'">
      <div class="contact-question-input">
        <label
          :for="`input-type-cpf-${index}`"
          :style="{
            color: textColor || '#000000',
          }"
        >
          {{ text }}
        </label>

        <input
          :style="{
            color: textColor || '#000000',
          }"
          type="text"
          v-mask="'###.###.###-##'"
          :id="`input-type-cpf-${index}`"
          v-model="cpf"
          :placeholder="placeholder"
          class="contact-question-input-text"
        />
      </div>
      <hr />
    </div>

    <div v-else>
      <div
        class="contact-question-input"
        style="display: flex; align-items: center; justify-content: center"
      >
        <label
          :for="`input-type-cpf-${index}`"
          :style="{
            color: textColor || '#000000',
          }"
        >
          {{ text }}
        </label>
      </div>
      <div
        class="contact-question-input-big"
        style="display: flex; align-items: center; justify-content: center"
      >
        <input
          :style="{
            color: textColor || '#000000',
          }"
          type="text"
          v-mask="'###.###.###-##'"
          :id="`input-type-cpf-${index}`"
          v-model="cpf"
          :placeholder="placeholder"
          class="contact-question-input-text"
          @input="sendToSearchPage($event.target.value, index)"
        />
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputTypeCpf',

  props: {
    text: {
      type: String,
      required: true,
    },
    textColor: { type: String, required: false },
    answerText: {
      type: String,
    },
    index: {
      type: Number,
      required: true,
    },
    justView: {
      type: Boolean,
    },
    addQuestionTemplate: { type: String, required: true, default: 'default' },
    isMandatoryForQuestion: { type: Boolean },
    placeholder: { type: String, required: true, default: 'Preencha aqui' },
  },

  watch: {
    cpf: function watchCpf(value) {
      this.sendToSearchPage(value);
    },
  },

  data: () => ({
    cpf: '',
  }),

  methods: {
    sendToSearchPage(answerText) {
      if (this.isMandatoryForQuestion) {
        this.$emit('input', {
          review: answerText,
          position: this.index,
        });
      } else {
        this.$emit('input', {
          review: answerText,
          position: this.index,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.answer-area {
  display: grid;
  justify-content: space-between;
}

.form-group {
  input {
    max-width: 500px;
  }
}

.contact-question-input {
  margin-top: 8px;
  display: grid;
  padding-left: 10px;
  padding-right: 10px;
  flex-direction: row;
  align-items: center;

  & > * {
    margin-right: 8px;
  }

  .contact-question-input-text {
    flex-grow: 1;
  }

  input {
    background: transparent;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: 1px solid $gray;

    &:focus {
      outline: none;
      border-bottom: 1px solid $gray;
    }
  }
}

.contact-question-input-big {
  margin-top: 8px;
  display: grid;
  padding-left: 10px;
  padding-right: 10px;
  flex-direction: row;
  align-items: center;

  & > * {
    margin-right: 8px;
  }

  .contact-question-input-text {
    width: 54%;
  }

  input {
    background: transparent;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: 1px solid $gray;

    &:focus {
      outline: none;
      border-bottom: 1px solid $gray;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/input-type-cpf/index.vue